/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */

window.initCustomFields = function initCustomFields(view) {
  let $customFieldInput = $('[name="custom_field"]');
  if ($customFieldInput.length <= 0) {
    return;
  }
  $customFieldInput = $customFieldInput.first();
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  const recordID = view.record_id;
  const readOnly = $customFieldInput.hasClass('read_only');

  if (!recordID) {
    // Must be a saved record to load custom fields.
    return;
  }

  const tabindex = $customFieldInput.prop('tabindex');
  const accountID = window.merchantos.session.getSystemCustomerID();
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  const recordType = view.name.split('.')[0];

  const hideFields = $('[name="hide_custom_fields"]').attr('value');

  let type = '';

  // eslint-disable-next-line default-case
  switch (recordType) {
    case 'item':
      type = 'Item';
      break;
    case 'purchase':
      type = 'Order';
      break;
    case 'customer':
      type = 'Customer';
      break;
    case 'item_group':
      type = 'ItemMatrix';
      break;
  }

  $.when(
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | number | null' is not a... Remove this comment to see the full error message
    window.merchantos.custom_fields.getRecordFields(accountID, type),
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | number | null' is not a... Remove this comment to see the full error message
    window.merchantos.custom_fields.getRecord(accountID, recordID, type)
  ).done((fields, record) => {
    if (type !== 'Item') {
      // eslint-disable-next-line no-param-reassign
      record = record[type];
    }
    // Do nothing if there are no custom fields on the record
    if (fields['@attributes'].count === 0) {
      if (Number(hideFields) === 1) {
        window.merchantos.custom_fields.hide();
      }
      return;
    }
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    window.merchantos.custom_fields.recordFields[type] = fields;
    window.merchantos.custom_fields.addCustomFields(fields.CustomField, record, tabindex, readOnly);

    window.merchantos.datepicker.init();
  });
};

class CustomFields implements MerchantosCustomFields {
  recordFields: any;

  constructor() {
    this.recordFields = {};
  }

  addCustomFields = (
    fields: CustomFieldInput | CustomFieldInput[],
    record: CustomFieldRecord,
    tabindex: number,
    readOnly: boolean
  ) => {
    const html = '<fieldset class="customfields" notranslate><ol><span class="bool_fields"></span>';
    $('[name="custom_field"]')
      .parent()
      .html(html);
    const $booleanArea = $<HTMLInputElement>('.bool_fields');
    $booleanArea.after('<span class="custom_fields"></span></ol></fieldset>');
    const $fieldArea = $<HTMLInputElement>('.custom_fields');

    if (!Array.isArray(fields)) {
      // eslint-disable-next-line no-param-reassign
      fields = [fields];
    }

    fields.forEach(field => {
      if (field) {
        // eslint-disable-next-line default-case
        switch (field.type) {
          case 'string':
          case 'url':
          case 'email':
          case 'date':
          case 'time':
          case 'datetime':
            this.buildField(field, record, 'string', $fieldArea, tabindex, readOnly);
            break;
          case 'boolean':
            this.buildField(field, record, 'boolean', $booleanArea, tabindex, readOnly);
            break;
          case 'integer':
          case 'float':
            this.buildField(field, record, 'number', $fieldArea, tabindex, readOnly);
            break;
          case 'text':
            this.buildField(field, record, 'textarea', $fieldArea, tabindex, readOnly);
            break;
          case 'single_choice':
            this.addSingleChoiceField(field, record, $fieldArea, tabindex, readOnly);
            break;
          case 'multi_choice':
            this.addMultiChoiceField(field, record, $fieldArea, readOnly);
            break;
        }
      }
    });
  };

  // Get the value(s) that belong to a particular field
  findValue = (
    fieldID: string,
    values: CustomFieldValue | CustomFieldValue[],
    isMultiSelect?: boolean
  ) => {
    if (!Array.isArray(values)) {
      // eslint-disable-next-line no-param-reassign
      values = [values];
    }

    let found;
    if (!isMultiSelect) {
      found = false;
    } else {
      found = [];
    }

    values.forEach(value => {
      if (value.customFieldID === fieldID) {
        if (!isMultiSelect) {
          found = value;
        } else {
          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          // eslint-disable-next-line no-param-reassign
          value.value.customFieldValueID = value.customFieldValueID;
          found.push(value.value);
        }
      }
    });
    return found;
  };

  // Determine HTML input type based on custom field type
  getInputType = (field: CustomFieldInput) => {
    let type = '';

    switch (field.type) {
      case 'integer':
      case 'float':
        type = 'number';
        break;
      case 'boolean':
        type = 'checkbox';
        break;
      case 'date':
      case 'time':
      case 'datetime':
      case 'email':
      case 'url':
        type = field.type;
        break;
      case 'string':
      default:
        type = 'text';
    }
    return type;
  };

  // Function to generate HTML for non-select fields
  buildField = (
    field: CustomFieldInput,
    record: CustomFieldRecord,
    customClass: string,
    target: JQuery<HTMLElement>,
    tabindex: number,
    readOnly: boolean
  ) => {
    let uom = '';
    let value: TSFixMe;
    let input;
    const type = this.getInputType(field);

    const li = `<li class="customfield-${customClass}">`;
    let label = '<label>';

    if (customClass !== 'boolean') {
      label += field.name;
      label += '</label>';
    }

    if (record.CustomFieldValues) {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
      value = this.findValue(field.customFieldID, record.CustomFieldValues.CustomFieldValue);
    }

    if (customClass !== 'textarea') {
      // No browsers have actually implemented datetime fields
      if (type === 'datetime') {
        // @ts-expect-error wrong types for underscore
        if (_.isObject(value) && value.value) {
          // @ts-expect-error wrong types for underscore
          value.value = this.timeZoneOffset(value.value);
          input = this.buildInput(field, $.extend({}, value), 'date', tabindex, readOnly);
          input += this.buildInput(field, $.extend({}, value), 'time', tabindex, readOnly);
        } else {
          input = this.buildInput(field, value, 'date', tabindex, readOnly);
          input += this.buildInput(field, value, 'time', tabindex, readOnly);
        }
      } else {
        input = this.buildInput(field, value, type, tabindex, readOnly);
      }
    } else {
      input = this.buildTextArea(field, value, tabindex, readOnly);
    }

    if (customClass === 'number' && field.uom) {
      uom = `<span class="customfield-unit-label">${field.uom}</span>`;
    }

    const error = '<span class="field-error hidden"><br>Invalid entry</span>';

    let closingTags;
    if (customClass === 'boolean') {
      closingTags = '</label></li>';
    } else {
      closingTags = '</li>';
    }

    const html = li + label + input + uom + error + closingTags;

    target.append($(html));
  };

  // Generate HTML for basic input types
  buildInput = (
    field: CustomFieldInput,
    value: CustomFieldValue,
    type: string,
    tabindex: number,
    readOnly: boolean
  ) => {
    let input = `<input type="${type}" `;
    if (tabindex) {
      // eslint-disable-next-line no-plusplus
      input += `tabindex="${tabindex++}"`;
    }

    if (type === 'text') {
      input += ' maxlength="64"';
    }

    if (type === 'text' || field.type === 'email') {
      input += ' data-type="email"';
    }

    if (readOnly) {
      input += ' disabled ';
    }
    let onchange = ' viewFieldChanged("view"); ';
    if (field.type === 'datetime') {
      if (type === 'date') {
        input += 'placeholder="Date" data-time="true" class="cf-date-input"';
      } else {
        input += 'placeholder="Time" data-date="true" ';
        input += "onchange=\" viewFieldChanged('view'); ";
        input += 'window.merchantos.time.checkTimeField(this);"';
      }
    } else {
      input += `placeholder="${field.name}"`;
    }

    if (field.type === 'float') {
      onchange += '  window.merchantos.custom_fields.validateFloat(this); ';
    }

    if (field.type === 'integer') {
      onchange += ' window.merchantos.custom_fields.validateInteger(this); ';
    }

    if (field.type === 'email') {
      onchange += ' window.merchantos.custom_fields.validateEmail(this); ';
    }

    if (field.type === 'url') {
      onchange += ' window.merchantos.custom_fields.validateURL(this); ';
    }

    if (field.type === 'date') {
      onchange += ' parseDateField(this); ';
    }

    input += ` onchange='${onchange}' `;

    input +=
      ' onkeypress="if (onEnterKey(event,function () { saveRecord(\'view\'); })) return false;"';
    input += ' onkeyup="viewFieldChanged(\'view\', this);"';

    if (_.isObject(value)) {
      if (type === 'checkbox' && value.value === 'true') {
        input += ' checked';
      }

      if (type === 'date' && value.value) {
        value.value = (value.value as string).split('T')[0];
      }

      if (type === 'time') {
        let time;

        if (!value.value) {
          time = [];
          value.value = '';
        } else {
          time = (value.value as string).split('T')[1];
          value.value = time;
        }

        if (time.length < 2) {
          value.value = '';
        }
      }

      // checkboxes rely on the checked property so don't set the value attribute
      if (type !== 'checkbox' && value.value) {
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | Partial<{ customFieldID... Remove this comment to see the full error message
        input += ` value="${this.escapeHTML(value.value)}" `;
      }

      input += ` name="${type}-${value.customFieldValueID}`;
      input += `-${field.customFieldID}">`;
    } else if (field.default) {
      if (type === 'checkbox' && field.default === 'true') {
        input += ' checked';
      } else if (type === 'date') {
        field.default = field.default.split('T')[0];
      } else if (type === 'time') {
        const defaultTime = field.default.split('T')[1];
        if (!defaultTime) {
          field.default = '';
        } else {
          // Time defaults shouldn't have a timezone offset
          field.default = defaultTime.split('+')[0];
        }
      }

      // checkboxes rely on the checked property so don't set the value attribute
      if (type !== 'checkbox') {
        input += ` value="${field.default}"`;
      }
      input += ` name="${type}-new-${field.customFieldID}">`;
    } else {
      input += ` name="${type}-new-${field.customFieldID}">`;
    }

    if (type === 'checkbox') {
      input += ` ${field.name}`;
    }

    return input;
  };

  // Offset a date and time by the browser's timezone
  // TODO:  This probably shouldn't be necessary.  The time returned by the
  // API should be accurate for the current shop.
  timeZoneOffset = (datetime: string) => {
    let date = datetime.split('T')[0];
    let time = datetime.split('T')[1];
    const xDate = new Date();
    const offset = xDate.getTimezoneOffset() / 60;
    let splitDate;
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'string[]' is not assignable to type 'string'... Remove this comment to see the full error message
    time = time.split('+')[0].split(':');
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'number' is not assignable to type 'string'.
    time[0] = parseInt(time[0], 10) - offset;

    // @ts-expect-error ts-migrate(2365) FIXME: Operator '<' cannot be applied to types 'string' a... Remove this comment to see the full error message
    if (time[0] < 0) {
      splitDate = date.split('-');
      // @ts-expect-error ts-migrate(2362) FIXME: The left-hand side of an arithmetic operation must... Remove this comment to see the full error message
      splitDate[2] = (splitDate[2] - 1).toString().padStart(2, '0');
      date = splitDate.join('-');
      // @ts-expect-error ts-migrate(2542) FIXME: Index signature in type 'String' only permits read... Remove this comment to see the full error message
      time[0] = 24 + time[0];
      // @ts-expect-error ts-migrate(2365) FIXME: Operator '>=' cannot be applied to types 'string' ... Remove this comment to see the full error message
    } else if (time[0] >= 24) {
      splitDate = date.split('-');
      splitDate[2] = (splitDate[2] + 1).toString().padStart(2, '0');
      date = splitDate.join('-');
      // @ts-expect-error ts-migrate(2362) FIXME: The left-hand side of an arithmetic operation must... Remove this comment to see the full error message
      time[0] -= 24;
    }

    // @ts-expect-error ts-migrate(2365) FIXME: Operator '<' cannot be applied to types 'string' a... Remove this comment to see the full error message
    if (time[0] < 10) {
      // @ts-expect-error ts-migrate(2542) FIXME: Index signature in type 'String' only permits read... Remove this comment to see the full error message
      time[0] = `0${time[0]}`;
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'join' does not exist on type 'string'.
    datetime = `${date}T${time.join(':')}`;
    return datetime;
  };

  // Generate HTML for text fields
  buildTextArea = (
    field: CustomFieldInput,
    value: CustomFieldValue,
    tabindex: number,
    readOnly: boolean
  ) => {
    let textarea = `<textarea placeholder="${field.name}" `;
    if (tabindex) {
      // eslint-disable-next-line no-plusplus
      textarea += `tabindex="${tabindex++}" `;
    }
    if (readOnly) {
      textarea += ' disabled ';
    }
    textarea += ' onchange="viewFieldChanged(\'view\')"';
    if (value) {
      textarea += ` value="${value.value}"`; // used later to get original value
      textarea += ` name="textarea-${value.customFieldValueID}`;
      textarea += `-${field.customFieldID}">`;
      textarea += value.value;
    } else if (field.default) {
      textarea += `name="textarea-new-${field.customFieldID}">`;
      textarea += field.default;
    } else {
      textarea += `name="textarea-new-${field.customFieldID}">`;
    }

    textarea += '</textarea>';

    return textarea;
  };

  validateInteger = (input: CustomFieldInput) => {
    $(input).removeClass('error');
    $(input)
      .siblings('.field-error')
      .addClass('hidden');
    if (isNaN(parseFloat(input.value)) && input.value !== '') {
      $(input).addClass('error');
      $(input)
        .siblings('.field-error')
        .removeClass('hidden');
    } else if (input.value !== '') {
      input.value = String(parseInt(String(Math.floor(Number(input.value))), 10));
    }
  };

  validateFloat = (input: CustomFieldInput) => {
    $(input).removeClass('error');
    $(input)
      .siblings('.field-error')
      .addClass('hidden');
    if (isNaN(parseFloat(input.value)) && input.value !== '') {
      $(input).addClass('error');
      $(input)
        .siblings('.field-error')
        .removeClass('hidden');
    }
  };

  validateEmail = (input: CustomFieldInput) => {
    $(input).removeClass('error');
    $(input)
      .siblings('.field-error')
      .addClass('hidden');
    if (!window.isEmail(input.value) && input.value !== '') {
      $(input).addClass('error');
      $(input)
        .siblings('.field-error')
        .removeClass('hidden');
    }
  };

  validateURL(input: TSFixMe) {
    $(input).removeClass('error');
    $(input)
      .siblings('.field-error')
      .addClass('hidden');
    if (!window.isURL(input.value) && input.value !== '') {
      $(input).addClass('error');
      $(input)
        .siblings('.field-error')
        .removeClass('hidden');
    }
  }

  // Generate HTML for single choice custom fields
  addSingleChoiceField = (
    field: CustomFieldInput,
    record: CustomFieldRecord,
    target: JQuery<HTMLElement>,
    tabindex: number,
    readOnly: boolean
  ) => {
    let value;
    let fieldDefault;
    if (record.CustomFieldValues) {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
      value = this.findValue(field.customFieldID, record.CustomFieldValues.CustomFieldValue);
    }

    // If no value is saved,  set the field's default as the value.
    if (!value && field.default) {
      fieldDefault = { value: field.default };
    }

    const li = '<li class="customfield-select">';
    const label = `<label>${field.name}`;
    const br = '<br>';
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'boolean | any[] | undefined' is ... Remove this comment to see the full error message
    const select = this.buildSingleSelect(field, value, fieldDefault, tabindex, readOnly);
    const closingTags = '</label></li>';

    const html = li + label + br + select + closingTags;
    target.append($(html));
  };

  // Generate HTML for select
  buildSingleSelect = (
    field: CustomFieldInput,
    value: CustomFieldValue,
    fieldDefault: CustomFieldValue,
    tabindex: number,
    readOnly: boolean
  ) => {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    let choices = field.CustomFieldChoices.CustomFieldChoice;
    if (!choices) {
      return;
    }

    if (!Array.isArray(choices)) {
      choices = [choices];
    }

    let select = `<select field-id="${field.customFieldID}" `;
    if (tabindex) {
      // eslint-disable-next-line no-plusplus
      select += `tabindex="${tabindex++}"`;
    }
    if (readOnly) {
      select += ' disabled ';
    }
    select += ' onchange="viewFieldChanged(\'view\');" ';
    if (value) {
      select += `name="select-${value.customFieldValueID}`;
      select += `-${field.customFieldID}">`;
    } else {
      select += `name="select-new-${field.customFieldID}">`;
    }

    // Create a blank option if there is no default.  If no value this is the selected field.
    // The ID currently-saved-choice-<customFieldID>  is set on the currently
    // selected option to detect changes and find the old value when saving.
    if (!fieldDefault) {
      select += '<option value="blank"';
      if (!value) {
        select += `selected id="currently-saved-choice-${field.customFieldID}" `;
      }
      select += '></option>';
    }

    choices.forEach(choice => {
      let option = `<option value="${choice.customFieldChoiceID}"`;
      if (
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'name' does not exist on type 'string | P... Remove this comment to see the full error message
        (value && value.value && choice.name === value.value.name) ||
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'name' does not exist on type 'string | P... Remove this comment to see the full error message
        (fieldDefault && fieldDefault.value && choice.name === fieldDefault.value.name)
      ) {
        option += ` selected id="currently-saved-choice-${field.customFieldID}" `;
      }
      option += '>';
      option += choice.name;
      option += '</option>';

      select += option;
    });

    select += '</select>';
    // eslint-disable-next-line consistent-return
    return select;
  };

  // Generate HTML for multiple-select custom fields
  addMultiChoiceField = (field: TSFixMe, record: TSFixMe, target: TSFixMe, readOnly: TSFixMe) => {
    let choices = field.CustomFieldChoices.CustomFieldChoice;
    if (!Array.isArray(choices)) {
      choices = [choices];
    }

    let selected = [];

    if (record.CustomFieldValues) {
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'boolean | any[]' is not assignable to type '... Remove this comment to see the full error message
      selected = this.findValue(
        field.customFieldID,
        record.CustomFieldValues.CustomFieldValue,
        true
      );
    }

    if (selected.length === 0 && field.default) {
      selected = field.default.CustomFieldChoice;

      if (!Array.isArray(selected)) {
        selected = [selected];
      }
    }

    const $choiceset = this.addMultiChoiceChoiceset(field, selected);
    target.append($choiceset);

    const $modal = this.addMultiChoiceModal(field, choices, selected);

    target.append($modal);

    // Bind click/touch event for the multi-choice 'field'
    if (!readOnly) {
      $choiceset.find('p').on('click', () => this.openChoiceModal($modal));

      // Bind click/touch events for the modal
      $modal.find('.dismiss').on('click', this.updateChoices);
      $modal.find('a.exit').on('click', () => this.closeChoiceModal($modal));
    }
  };

  addMultiChoiceChoiceset = (field: CustomFieldInput, selected: CustomFieldValue[]) => {
    const li = '<li class="customfield-choiceset">';
    const label = `<label>${field.name}</label>`;
    let choiceset;

    if (selected.length > 0) {
      const selectedValues: TSFixMe = [];
      choiceset = '<p class="customfield-choiceset-active"';
      choiceset += ` id="choiceset${field.customFieldID}">`;
      selected.forEach(value => selectedValues.push(value.name));
      choiceset += `${selectedValues.join(', ')}</p>`;
    } else {
      choiceset = '<p class="customfield-choiceset-active"';
      choiceset += ` id="choiceset${field.customFieldID}`;
      choiceset += '"><span class="blank">None specified</span></p>';
    }

    const html = `${li + label + choiceset}</li>`;
    return $(html);
  };

  addMultiChoiceModal = (
    field: CustomFieldInput,
    choices: CustomFieldValue[],
    selected: CustomFieldValue[]
  ) => {
    const selectedValues: TSFixMe = [];
    selected.forEach(value => selectedValues.push(value.name));

    let divs = '<div class="lscloud_modal modal_container hidden" ';
    divs += `id="multichoice-modal-${field.customFieldID}">`;
    divs += '<div class="modal_content wide has-footer">';

    let header = '<header><h4>Custom Field Choices</h4>';
    header += `<h1>${field.name}</h1></header>`;

    let form = `<form id="choices${field.customFieldID}" class="choices">`;
    form += '<fieldset class="modal-choiceset"><ol>';
    form += `<input type="hidden" name="field-id" value="${field.customFieldID}">`;
    choices.forEach(choice => {
      let li = '<li><label class="checkbox">';
      li += `<input type="checkbox" value="${choice.name}" `;

      const index = selectedValues.indexOf(choice.name);
      if (index !== -1) {
        if (selected[index].customFieldValueID) {
          // If there is a customFieldValueID,  this is a previously
          // selected / saved choice and not a default.
          li += `name="choice-${selected[index].customFieldValueID}`;
          li += `-${field.customFieldID}-${choice.customFieldChoiceID}"`;
          li += ' checked';
        } else {
          // If there is not a customFieldValueID,  this is a default choice.
          li += `name="choice-default-${field.customFieldID}`;
          li += `-${choice.customFieldChoiceID}"`;
          li += ' checked';
        }
      } else {
        li += `name="choice-new-${field.customFieldID}-`;
        li += `${choice.customFieldChoiceID}"`;
      }
      li += `> ${choice.name}`;
      li += '</label></li>';

      form += li;
    });
    form += '</ol></fieldset>';

    let footer = '<footer><a class="lscloud_button dismiss">Update Choices</a>';
    footer += '<a class="exit">Cancel &amp; discard changes</a></footer></form></div></div>';

    const modal = divs + header + form + footer;
    return $(modal);
  };

  openChoiceModal = (modal: JQuery<HTMLElement>) => {
    modal.removeClass('hidden');
  };

  closeChoiceModal = (modal: JQuery<HTMLElement>) => {
    modal.addClass('hidden');
  };

  updateChoices = ({ target }: TSFixMe) => {
    const form = $(target).closest('form');
    const data = $(form).serializeArray();
    const id = data[0].value;

    const values = [];
    const $field = $(`#choiceset${id}`);
    // eslint-disable-next-line no-plusplus
    for (let i = 1; i < data.length; i++) {
      values.push(data[i].value);
    }
    if (values.length === 0) {
      $field.html('None specified');
    } else {
      $field.html(values.join(', '));
    }

    const $modal = $(target).closest('.lscloud_modal');
    window.viewFieldChanged('view');
    this.closeChoiceModal($modal);
  };

  getRecordFields = (accountID: string, recordType: string) => {
    if (this.recordFields[recordType]) {
      return this.recordFields[recordType];
    }
    const params = '?orderby=name&load_relations=["Default", "CustomFieldChoices"]';
    const path = `/API/Account/${accountID}/${recordType}/CustomField${params}`;
    return window.lsCloud.getJSONFromAPI(path);
  };

  getRecord = (accountID: string, recordID: string, recordType: string) => {
    if (recordType == 'Item') {
      return window.merchantos.itemCaching.load(recordID);
    }
    const params = '?load_relations=["CustomFieldValues"]';
    const path = `/API/Account/${accountID}/${recordType}/${recordID}${params}`;
    return window.lsCloud.getJSONFromAPI(path);
  };

  constructUpdateData = ($fields: JQuery<HTMLElement>, view: PanelData['view']) => {
    const data = $fields.serializeArray();
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    const recordID = view.record_id;
    if (_.isUndefined(recordID) || recordID <= 0) {
      return;
    }

    const customFieldValues = [];
    const unchecked = $fields.find('input[type="checkbox"]:not(:checked)');

    let i;
    let fieldInfo;
    let type;
    let valueID;
    let fieldID;
    let choiceID;
    let value;
    let deleted;
    let valueJSON;
    let originalValue;
    // eslint-disable-next-line no-plusplus
    for (i = 0; i < data.length; i++) {
      if (data[i].name === 'field-id') {
        // eslint-disable-next-line no-continue
        continue;
      }

      fieldInfo = data[i].name.split('-');

      type = fieldInfo[0];
      valueID = fieldInfo[1];
      fieldID = fieldInfo[2];
      choiceID = fieldInfo[3];
      value = data[i].value;
      deleted = false;
      originalValue = $(`[name="${data[i].name}"]`).attr('value');

      // If the selected choice hasn't changed continue to the next input.
      if (type === 'select' && $(`#currently-saved-choice-${fieldID}`).val() === value) {
        // eslint-disable-next-line no-continue
        continue;
      }

      // Time fields get handled together with the dates
      if (type === 'time') {
        // eslint-disable-next-line no-continue
        continue;
      }

      if (value === 'blank' || (originalValue && value === '')) {
        deleted = true;
      }

      value = this.normalizeValueForUpdate(data, i, type, fieldID, choiceID, value);
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | number | boolean | { cu... Remove this comment to see the full error message
      valueJSON = this.buildCustomFieldValue(fieldID, value, valueID, deleted);
      customFieldValues.push(valueJSON);
    }

    // eslint-disable-next-line no-plusplus
    for (i = 0; i < unchecked.length; i++) {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      fieldInfo = unchecked[i].name.split('-');

      type = fieldInfo[0];
      valueID = fieldInfo[1];
      fieldID = fieldInfo[2];
      choiceID = fieldInfo[3];
      deleted = false;

      if (type === 'choice') {
        deleted = true;
        value = { customFieldChoiceID: choiceID };
      } else {
        value = false;
      }

      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'boolean | { customFieldChoiceID:... Remove this comment to see the full error message
      valueJSON = this.buildCustomFieldValue(fieldID, value, valueID, deleted, type);
      customFieldValues.push(valueJSON);
    }

    // eslint-disable-next-line consistent-return
    return { CustomFieldValues: { CustomFieldValue: customFieldValues } };
  };

  buildCustomFieldValue = (
    fieldID: string,
    value: CustomFieldValue,
    valueID: string,
    deleted: boolean,
    type?: string
  ) => {
    const customFieldValue: CustomFieldValue = {
      customFieldID: fieldID,
    };
    if (type === 'checkbox' || value) {
      customFieldValue.value = value;
    }
    if (valueID !== 'new' && valueID !== 'default') {
      customFieldValue.customFieldValueID = valueID;
    }
    if (deleted) {
      customFieldValue.deleted = true;
    }
    return customFieldValue;
  };

  normalizeValueForUpdate = (
    data: CustomFieldValue[],
    i: number,
    type: string,
    fieldID: string,
    choiceID: string,
    value: string
  ) => {
    if (type === 'checkbox' && value === 'on') {
      return true;
    }

    if (type === 'date') {
      // Parse date field expects an HTML node.  But can work with a POJO
      // if it has a value key/value
      value = window.parseDateField({ value } as HTMLInputElement);
      if (data[i + 1]) {
        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        const nextField = data[i + 1].name.split('-');
        if (nextField[2] === fieldID) {
          const hidden = {} as HTMLInputElement;
          // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'Partial<{ customFieldID: string;... Remove this comment to see the full error message
          window.combineDateTime(hidden, data[i], data[i + 1]);
          value = hidden.value;
        }
      }
      return value;
    }

    if (type === 'select') {
      // If the value being saved is "blank" we need to delete the old value
      // rather than set a new one.  Old value has the id #currently-saved-choice-<fieldID>
      if (value === 'blank') {
        return { customFieldChoiceID: $(`#currently-saved-choice-${fieldID}`).val() as string };
      }
      return { customFieldChoiceID: value };
    }

    if (type === 'choice') {
      return { customFieldChoiceID: choiceID };
    }

    if (value === 'blank') {
      if (type === 'date') {
        return false;
      }
      return 0;
    }

    return value;
  };

  setHidden = () => {
    const sysCustomerID = window.merchantos.session.getSystemCustomerID();
    let xml = '<Options><Option><name>hide_custom_fields</name>';
    xml += '<value>true</value></Option></Options>';

    window.lsCloud
      .startServerJob(
        {
          type: 'PUT',
          url: `/API/Account/${sysCustomerID}/Option`,
          data: xml,
        },
        true
      )
      .done(() => this.hide());
  };

  hide = () => {
    $('[name="custom_field"]')
      .closest('table.tab_columns')
      .addClass('hidden');
  };

  escapeHTML = (html: string) => {
    const entityMap = {
      '"': '&quot;',
      '&': '&amp;',
      "'": '&#039;',
      '<': '&lt;',
      '>': '&gt;',
      '\\': '&bsol;',
    };

    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    return html.replace(/[&<>"'\\]/g, s => entityMap[s]);
  };
}

window.merchantos.custom_fields = new CustomFields();
